import type { FaireProductEntity } from "../../entity_types/product";

export const atc_baggu_5: FaireProductEntity = {
  token: "atc_baggu_5",
  type: "product",
  name: "Go Pouch Set of 3 - Fruit & Veggie",
  brandName: "Baggu",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b961c86c8e51fe14f132078339cfcb9c3523bd719de39a86d5c4ee7056cab4d0.jpeg",
  priceDollars: 16,
  msrpDollars: 32,
  description: "Reusable bag made from recycled materials by Baggu.",
  tags: ["bags", "accessories", "sustainable"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
